import { axios } from '@/utils/request'

export function fetchList (params) {
  return axios({
    url: '/sxSupplier/page',
    method: 'GET',
    params: {
      ...params
    }
  })
}

export function delObj (id) {
  return axios({
    url: `/sxSupplier/${id}`,
    method: 'DELETE'
  })
}
export function getObj (id) {
  return axios({
    url: `/sxSupplier/${id}`,
    method: 'GET'
  })
}
export function addObj (params) {
  return axios({
    url: `/sxSupplier/save`,
    method: 'POST',
    data: {
      ...params
    }
  })
}
export function putObj (params) {
  return axios({
    url: `/sxSupplier/update`,
    method: 'POST',
    data: {
      ...params
    }
  })
}

export function dropSupplierList () {
  return axios({
    url: `/sxSupplier/dropDown`,
    method: 'Get'
  })
}
